import React, { Fragment } from 'react';

const Suspended = ({ city = 'toronto' }) => (
  <Fragment>
    <div>Your Autzu account will automatically be suspended if:</div>
    <ul>
      <li>You are holding a negative balance</li>
      <li>One or more of your documents have expired</li>
      <li>
        Your rideshare driver account status is no longer “Active” or your
        connection has expired
      </li>
    </ul>
    <br />
    <div>
      Any of these issues can be resolved directly through the Autzu app.
      Once they are resolved, your Autzu account will automatically revert
      back to active!
    </div>
  </Fragment>
);

export default Suspended;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/AccountIssues/Suspended.js